@file:OptIn(ExperimentalSerializationApi::class)

package org.ssoft.common.server.icons

import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.Serializable
import kotlinx.serialization.protobuf.ProtoNumber

@Serializable
sealed interface IconIO {

    val query: String

    @Serializable
    data class Random(
        @ProtoNumber(1)
        override val query: String = "",
        @ProtoNumber(2)
        var exclusion: List<Long> = listOf()
    ) : IconIO

    @Serializable
    data class Query(
        @ProtoNumber(1)
        override val query: String,
        @ProtoNumber(2)
        var offset: Int = 0
    ) : IconIO

    @Serializable
    data class Result(
        @ProtoNumber(1)
        val items: MutableList<Item> = mutableListOf(),
        @ProtoNumber(2)
        var offset: Int = 0
    ) {
        @Serializable
        data class Item(
            @ProtoNumber(1)
            val id: Long = -1L,
            @ProtoNumber(2)
            val name: String = ""
        )
    }
}